import React from 'react'
import translate from '../../core/translate'
import styles from './inputField.jcss'

interface IInputFieldProps {
    label: string
    value: string | number
    onChange: (value: string) => void
    required?: boolean
    placeholder?: string
    sampleText?: string
    tooltipText?: string
    disabled?: boolean
    type?: string
}

export const InputField = ({
    label,
    value,
    onChange,
    required,
    placeholder,
    sampleText,
    tooltipText,
    disabled,
    type,
}: IInputFieldProps) => {
    return (
        <div className={styles.inputFieldContainer}>
            {label && (
                <div className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </div>
            )}
            <div className={styles.inputFieldWrapper}>
                <input
                    type={type || 'text'}
                    className={styles.input}
                    value={value}
                    placeholder={placeholder}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={disabled}
                />
            </div>
            {(sampleText || tooltipText) && (
                <div className={styles.sample}>
                    {sampleText ? (
                        <>
                            {translate('sample')}: {sampleText}
                        </>
                    ) : (
                        tooltipText
                    )}
                </div>
            )}
        </div>
    )
}
